
import React, { useState, useEffect, ReactNode } from 'react';
import { Tabs } from 'antd';
import { http } from '@ud/admin-framework';
import { Redirect } from 'react-router-dom';
const { TabPane } = Tabs;

const SelfTabs: React.FC<ISelfTabsProps> = (props) => {
  const [tabList, setTabList] = useState<ReactNode>([])

  const getTabs = () => {
    if (props.tabList && props.tabList.length > 0) {
      const node = props.tabList.map((v: any) => {
        return (
          <TabPane tab={v.name} key={v.id}>
            {/* <div>
              {v.render}
            </div> */}
          </TabPane >
        )
      })
      setTabList(node)
    }
  }

  useEffect(() => {
    getTabs()
  }, [])

  const clickTab = (v: any) => {
    props.clickTab && props.clickTab(v)
  }

  return (
    <Tabs onChange={clickTab}>

      {tabList}


    </Tabs>
  )
}

interface ISelfTabsProps {
  ajaxUrl?: string
  clickTab?: any
  tabList?: any
}


export default SelfTabs